import React, { lazy } from 'react'
import { Switch, Route } from 'react-router-dom'
import { SingleUseLinkProvider } from 'app/guest-app/singleUseLinkContext'
import { BookingStateProvider } from '@chilipiper/booking-flow-legacy'
import { GuestProvider } from './app/guest-app/guestContext'
import AvailabilityConnected from './availability/Availability'

const FlowChooser = lazy(() => import('./availability/flow-chooser/FlowChooser'))
const BookedConnected = lazy(() => import('./availability/booked-page'))
const BookedSeries = lazy(() => import('./availability/BookedSeries'))
const NotAvailable = lazy(() => import('./availability/components/not-available/NotAvailable'))
const Book = lazy(() => import('./availability/components/book/Book'))
const Dialer = lazy(() => import('./availability/dialer/Dialer'))
const Requested = lazy(() => import('./availability/Requested'))
const OnlineSelectorConnected = lazy(() => import('./selector/OnlineSelector'))
const OpenedInAnotherTab = lazy(() => import('./availability/OpenedInAnotherTab'))
const CriticalError = lazy(() => import('./availability/CriticalError'))
const MaxMeetingsReached = lazy(
  () => import('./availability/components/max-meetings-reached/MaxMeetingsReached')
)
const AvailabilityMeetingSeries = lazy(
  () => import('./availability/series/AvailabilityMeetingSeries')
)

export const Booking = () => {
  return (
    <BookingStateProvider>
      <SingleUseLinkProvider>
        <GuestProvider>
          <Switch>
            <Route exact path='*/once/:singleUseLinkId' component={AvailabilityConnected} />
            <Route path='*/all' component={OnlineSelectorConnected} />
            <Route path='*/booked' component={BookedConnected} />
            <Route path='*/series' component={AvailabilityMeetingSeries} />
            <Route path='*/dialer' component={Dialer} />
            <Route path='*/calendar' component={AvailabilityConnected} />
            <Route path='*/requested' component={Requested} />
            <Route path='*/reschedule' component={AvailabilityConnected} />
            <Route path='*/another-tab' component={OpenedInAnotherTab} />
            <Route path='*/intermidiate' component={FlowChooser} />
            <Route path='*/booked-series' component={BookedSeries} />
            <Route path='*/not-available' component={NotAvailable} />
            <Route path='*/critical-error' component={CriticalError} />
            <Route path='*/max-meetings-reached' component={MaxMeetingsReached} />
            <Route path='*/domain-max-meetings-reached' component={MaxMeetingsReached} />
            <Route exact path='*/book' component={Book} />
            <Route path='*' component={AvailabilityConnected} />
          </Switch>
        </GuestProvider>
      </SingleUseLinkProvider>
    </BookingStateProvider>
  )
}

export default Booking
